import React, { useState } from 'react';
import { Button } from 'antd';
import { hasAccess } from '../../utils';
import { useTranslation } from 'react-i18next';
import useFetch from "../../hooks/useFetch";
import useMessageUser from "../../hooks/useMessageUser";

interface DownloadZipButtonProps {
    url: string;
    filters: Record<string, any>;
    roles?: string[];
    labelKey?: string;
}

const DownloadZipButton: React.FC<DownloadZipButtonProps> = ({
                                                                 url,
                                                                 filters,
                                                                 roles = ['ROLE_GUEST', 'ROLE_SYSADMIN'],
                                                                 labelKey = 'btnDownloadPhotos'
                                                             }) => {
    const [loading, setLoading] = useState(false);
    const { downloadFile } = useFetch();
    const { showMessage }  = useMessageUser();
    const { t } = useTranslation();

    const downloadImages = () => {
        setLoading(true);
        downloadFile(url, filters).then((response: any) => {
            const dateNow = new Date().toISOString();

            if (response.status === 200) {
                const urlBlob = URL.createObjectURL(response.data);
                const link = document.createElement('a');
                link.href = urlBlob;
                link.download = `${dateNow}_photos.zip`;
                document.body.appendChild(link);
                link.click();
                URL.revokeObjectURL(urlBlob);
            } else {
                showMessage('ExceptionNoFiles', 'info');
            }
        }).catch((err) => {
            showMessage(err?.message || 'Error al descargar', 'error');
        }).finally(() => {
            setLoading(false);
        });
    };

    if (!hasAccess(roles)) return null;

    return (
        <Button
            loading={loading}
            type="primary"
            onClick={downloadImages}
        >
            {t(labelKey)}
        </Button>
    );
};

export default DownloadZipButton;
